import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AccessComponent } from './demo/components/auth/access/access.component';
import { roleGuard } from 'src/app/demo/guards/role.guard';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: 'sigp',
        component: AppLayoutComponent,
        canActivate: [roleGuard],
        canActivateChild: [roleGuard],
        children: [
          { path: 'modulos', loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) }
        ]
      },
      { path: 'unauthorized', component: AccessComponent },
      { path: 'not-found', component: NotfoundComponent },
      { path: '', loadChildren: () => import('./demo/components/auth/landing/landing.module').then(m => m.LandingModule) },
      { path: '**', redirectTo: '/not-found' },

    ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}